import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AnimationOptions } from 'ngx-lottie';
import { Subscription } from 'rxjs';
import { LanguageService } from 'src/app/service/language-service/language.service';
import { RewardsService } from 'src/app/service/rewards/rewards.service';

@Component({
  selector: 'app-reward-received-modal',
  templateUrl: './reward-received-modal.component.html',
  styleUrls: ['./reward-received-modal.component.scss'],
})
export class RewardReceivedModalComponent  implements OnInit {
  @Input() coinsReceived: string = "";
  @Input() coinsName: string = "";
  @Input() reasons = [];
  @Input() coinImage: string = "";
  // currencyName: string = "";
  showConfetti = true

  coinJumpOptions: AnimationOptions = {
    path: '/assets/animations/coins-jump.json',
    loop: true,
    autoplay: true
  };
  language:string = "es";
  laguageSub: Subscription;

  constructor(
    private modalCtrl: ModalController,
    private languageService: LanguageService,
    // private rewardsService: RewardsService,
  ) {
    // this.currencyName =  this.rewardsService.currencyName;
  }

  ngOnInit() {
    this.subLanguageConfig();
    setTimeout(() => {
      this.showConfetti = false;
    }, 2000);
  }

  subLanguageConfig() {
    this.laguageSub = this.languageService.getCurrentLang().subscribe(lang => {
      this.language = lang;
    });
  }

  closeModal() {
		this.modalCtrl.dismiss();
	}

}
